(function () {

  // =========================================================================
  // Prevent duplicate script initialization
  // =========================================================================
  if (window.__giftSyncInitialized) return;
  window.__giftSyncInitialized = true;

  // =========================================================================
  // Blocking products — declared BEFORE TIERED_GIFT_RULES
  // =========================================================================

  const BLOCKING_PRODUCTS = [
    42292249198754, //After Bite Turmeric Balm for Mosquito & Insect Bite Relief
    45208160043170, //Mosquito Repellent Patches + After Bite Turmeric Balm
    44071033340066  //Insects & Mosquitos Go Away Kit for Babies
  ];

  //*****Exclude products******
  // After Bite Turmeric Balm for Mosquito & Insect Bite Relief - 25gram,
  // Mosquito Repellent Patches + After Bite Turmeric Balm
  // Insects & Mosquitos Go Away Kit for Babies


  // =========================================================================
  // Tiered gift rules
  // =========================================================================

  const TIERED_GIFT_RULES = [
    // {
    //   name: 'Free mini 99% Pure Water Unscented Baby Wipes - 5 Pcs',
    //   variantId: 45975108583586,
    //   minAmount: 0
    // },
    // {
    //   name: 'Free After Bite Turmeric Balm - 8gm',
    //   variantId: 45796304683170,
    //   minAmount: 299,
    //   blockedBy: BLOCKING_PRODUCTS
    // },
    // {
    //   name: 'Detergent',
    //   variantId: 45582467793058,
    //   minAmount: 499
    // },
    // {
    //   name: 'Plant Powered Baby Wipes - Cucumber (40Pcs)',
    //   variantId: 47620871848098,
    //   minAmount: 649
    // },
    // {
    //   name: 'Blue Bag',
    //   variantId: 45805238386850,
    //   minAmount: 1199
    // },
    {
      name: 'Vintage Box',
      variantId: 41120619004066,
      minAmount: 1499
    }
  ];


  // =========================================================================
  // Special gifts
  // =========================================================================

  const SPECIAL_GIFT_ID = 49747017564375; //Free After Bite Turmeric Balm - 8gm (App)

  // const SPECIAL_GIFT_ID_NEW = 47505504043170;

  const SPECIAL_GIFT_NEW_THRESHOLD = 10;
  const GIFT_1499_ID = 49737838985431;// Free vintage box
  const THRESHOLD_1499 = 1499;

  // =========================================================================
  // Adjustment products
  // =========================================================================

  const ADJUSTMENT_PRODUCTS = [
    {
      variantId: 48131756720343, //99% Pure Water Unscented Baby Wipes - Medical Grade Fabric (72 pcs) => 4 Pack(72Nx4)
      deductAmount: 1196
    },
    {
      variantId: 48131756753111, //99% Pure Water Unscented Baby Wipes - Medical Grade Fabric (72 pcs) => 3 Pack(72Nx3)
      deductAmount: 897
    },
    {
      variantId: 48131756785879, //99% Pure Water Unscented Baby Wipes - Medical Grade Fabric (72 pcs) => 2 Pack(72Nx2)
      deductAmount: 598
    },
    {
      variantId: 48131756818647, //99% Pure Water Unscented Baby Wipes - Medical Grade Fabric (72 pcs) => 1 Pack(72N)
      deductAmount: 299
    }
  ];


  // =========================================================================
  // Remove free product
  // =========================================================================

  const REMOVE_FREE_PRODUCT_ID = 48131757277399; //Free mini 99% Pure Water Unscented Baby Wipes - 5 Pcs


  // =========================================================================
  // Every free/gift product
  // =========================================================================

  const FREE_PRODUCT_IDS = [
    ...TIERED_GIFT_RULES.map(r => r.variantId).filter(Boolean),
    // SPECIAL_GIFT_ID_NEW,
    GIFT_1499_ID,
    REMOVE_FREE_PRODUCT_ID,
    SPECIAL_GIFT_ID
  ];


  let isUpdatingGifts = false;


  // =========================================================================
  // Product tag cache
  // =========================================================================

  const PRODUCT_TAG_CACHE = {};


  // =========================================================================
  // Unavailable variants
  // =========================================================================

  const UNAVAILABLE_VARIANTS = new Set();


  // =========================================================================
  // AJAX timeout
  // =========================================================================

  const AJAX_TIMEOUT_MS = 8000;


  // =========================================================================
  // Rate-limit (429) handling — reload the page when Shopify's cart API
  // starts rejecting requests, since at that point the cart/DOM state can no
  // longer be trusted to stay in sync via further AJAX calls. A cooldown
  // guard (sessionStorage) prevents a reload-loop if the page reloads and
  // immediately gets rate-limited again (e.g. the limit hasn't cleared yet).
  // =========================================================================

  const RELOAD_COOLDOWN_MS = 10000;
  const RELOAD_COOLDOWN_KEY = '__giftSyncLastReload';

  function isRateLimited(err) {
    // jQuery's ajax error callback gives a jqXHR with .status.
    // A raw fetch Response object also exposes .status directly.
    return !!err && Number(err.status) === 429;
  }

  function reloadPageOnFailure(reason) {
    const lastReload = Number(sessionStorage.getItem(RELOAD_COOLDOWN_KEY) || 0);
    const now = Date.now();

    if (now - lastReload < RELOAD_COOLDOWN_MS) {
      console.error(
        'Cart request rate-limited again shortly after a reload — skipping another reload to avoid a loop.',
        reason
      );
      return;
    }

    sessionStorage.setItem(RELOAD_COOLDOWN_KEY, String(now));
    console.error('Cart request rate-limited (429) — reloading page.', reason);
    window.location.reload();
  }


  // =========================================================================
  // Checkout lock
  // =========================================================================

  function toggleCheckoutButtons(disable) {
    const selectors = [
      '.gokwik-checkout',
      '[name="checkout"]',
      'a[href="/checkout"]',
      'form[action="/cart"] [type="submit"]',
      '.cart__checkout-button'
    ];

    const buttons = document.querySelectorAll(selectors.join(','));

    buttons.forEach(btn => {
      if (disable) {
        btn.setAttribute('data-disabled-by-sync', 'true');
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.5';
      } else {
        btn.removeAttribute('data-disabled-by-sync');
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      }
    });
  }


  // =========================================================================
  // Tag lookup
  // =========================================================================

  async function checkHasRemoveFreeTag(cartItems) {
    const fetchPromises = cartItems.map(async item => {
      if (!item.handle) return false;

      if (PRODUCT_TAG_CACHE[item.handle] !== undefined) {
        return PRODUCT_TAG_CACHE[item.handle];
      }

      try {
        const res = await fetch(`/products/${item.handle}.js`);
        const product = await res.json();
        const hasTag = Boolean(product.tags && product.tags.includes('remove_free_99'));
        PRODUCT_TAG_CACHE[item.handle] = hasTag;
        return hasTag;
      } catch {
        PRODUCT_TAG_CACHE[item.handle] = false;
        return false;
      }
    });

    const results = await Promise.all(fetchPromises);
    return results.some(Boolean);
  }


  // =========================================================================
  // Rule: tiered gifts
  // =========================================================================

  function ruleTieredGifts(cart, totalCartAmount, updates) {
    for (const rule of TIERED_GIFT_RULES) {
      if (!rule.variantId) continue;

      const hasGift = cart.items.some(item => item.id == rule.variantId);

      const hasBlockingProduct = rule.blockedBy
        ? cart.items.some(item => rule.blockedBy.includes(item.id))
        : false;

      const qualifies = totalCartAmount > rule.minAmount && !hasBlockingProduct;

      if (qualifies && !hasGift) {
        updates[rule.variantId] = 1;
      }

      if (!qualifies && hasGift) {
        updates[rule.variantId] = 0;
      }
    }
  }


  // =========================================================================
  // Rule: special gift
  // =========================================================================

  function ruleSpecialGift(cart, totalCartAmount, updates) {
    const hasSpecialGift = cart.items.some(item => item.id == SPECIAL_GIFT_ID);
    const hasBlockingProduct = cart.items.some(item => BLOCKING_PRODUCTS.includes(item.id));

    if (totalCartAmount > 299 && !hasBlockingProduct && !hasSpecialGift) {
      updates[SPECIAL_GIFT_ID] = 1;
    } else if (hasSpecialGift && (totalCartAmount <= 299 || hasBlockingProduct)) {
      updates[SPECIAL_GIFT_ID] = 0;
    }
  }


  // =========================================================================
  // Rule: new special gift
  // =========================================================================

  function ruleSpecialGiftNew(cart, totalCartAmount, updates) {
    const hasNewSpecialGift = cart.items.some(item => item.id);

    if (totalCartAmount > SPECIAL_GIFT_NEW_THRESHOLD && !hasNewSpecialGift) {
      // updates[SPECIAL_GIFT_ID_NEW] = 1;
    } else if (totalCartAmount <= SPECIAL_GIFT_NEW_THRESHOLD && hasNewSpecialGift) {
      // updates[SPECIAL_GIFT_ID_NEW] = 0;
    }
  }


  // =========================================================================
  // Rule: 1499 gift
  // =========================================================================

  function rule1499Gift(cart, totalCartAmount, updates) {
    const deductAmount = ADJUSTMENT_PRODUCTS.reduce((sum, adj) => {
      const item = cart.items.find(i => i.id == adj.variantId);
      return sum + (item ? item.quantity * adj.deductAmount : 0);
    }, 0);

    const effectiveTotal = totalCartAmount - deductAmount;
    const has1499Gift = cart.items.some(item => item.id == GIFT_1499_ID);

    if (effectiveTotal > THRESHOLD_1499 && !has1499Gift) {
      updates[GIFT_1499_ID] = 1;
    } else if (effectiveTotal <= THRESHOLD_1499 && has1499Gift) {
      updates[GIFT_1499_ID] = 0;
    }
  }


  // =========================================================================
  // Rule: remove free product
  // =========================================================================

  async function ruleRemoveFreeProduct(cart, updates) {
    const hasFreeProduct = cart.items.some(item => item.id == REMOVE_FREE_PRODUCT_ID);
    const hasProductPrice = cart.items.some(item => item.final_price > 1);
    const hasRemoveFreeTag = await checkHasRemoveFreeTag(cart.items);

    if (!hasRemoveFreeTag && !hasFreeProduct && hasProductPrice) {
      updates[REMOVE_FREE_PRODUCT_ID] = 0;
    } else if (hasFreeProduct && (hasRemoveFreeTag || !hasProductPrice)) {
      updates[REMOVE_FREE_PRODUCT_ID] = 0;
    }
  }


  // =========================================================================
  // Rule: cap free gift quantity
  // =========================================================================

  function ruleCapFreeGiftQuantities(cart, updates) {
    for (const item of cart.items) {
      if (
        FREE_PRODUCT_IDS.includes(item.id) &&
        item.quantity > 1 &&
        updates[item.id] === undefined
      ) {
        updates[item.id] = 1;
      }
    }
  }


  // =========================================================================
  // Main gift synchronization
  // =========================================================================

  async function syncAllGifts() {
    if (isUpdatingGifts) return;

    isUpdatingGifts = true;
    toggleCheckoutButtons(true);

    const cartDrawer = document.querySelector('cart-drawer.drawer');
    const mainCart = document.querySelector('#main-cart-items');

    try {
      let cart;
      try {
        const cartRes = await fetch('/cart.js');

        // fetch() only rejects on network failure, not on HTTP error status
        // codes — a 429 response resolves normally, so it must be checked
        // explicitly here rather than relying on the catch block below.
        if (cartRes.status === 429) {
          reloadPageOnFailure('GET /cart.js rate limited (429)');
          return;
        }

        if (!cartRes.ok) {
          console.error('Error fetching cart, status:', cartRes.status);
          return;
        }

        cart = await cartRes.json();
      } catch (err) {
        console.error('Error fetching cart:', err);
        return;
      }

      const updates = {};
      const totalCartAmount = cart.total_price / 100;

      ruleTieredGifts(cart, totalCartAmount, updates);
      ruleSpecialGift(cart, totalCartAmount, updates);
      ruleSpecialGiftNew(cart, totalCartAmount, updates);
      rule1499Gift(cart, totalCartAmount, updates);
      await ruleRemoveFreeProduct(cart, updates);
      ruleCapFreeGiftQuantities(cart, updates);

      // Don't retry unavailable variants
      for (const variantId of Object.keys(updates)) {
        if (updates[variantId] > 0 && UNAVAILABLE_VARIANTS.has(String(variantId))) {
          delete updates[variantId];
        }
      }

      if (Object.keys(updates).length === 0) {
        return;
      }

      if (cartDrawer) {
        $(cartDrawer).addClass('loading');
      }

      if (mainCart) {
        mainCart.classList.add('loading');
      }

      try {
        await new Promise((resolve, reject) => {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: updates },
            dataType: 'json',
            timeout: AJAX_TIMEOUT_MS,
            success: resolve,
            error: reject
          });
        });

      } catch (batchErr) {

        if (isRateLimited(batchErr)) {
          reloadPageOnFailure('POST /cart/update.js rate limited (429)');
          return;
        }

        console.warn(
          'Batch cart update failed — retrying updates individually.',
          batchErr
        );

        for (const [variantId, qty] of Object.entries(updates)) {
          try {
            await new Promise((resolve, reject) => {
              $.ajax({
                type: 'POST',
                url: qty > 0 ? '/cart/add.js' : '/cart/change.js',
                data: qty > 0
                  ? { id: variantId, quantity: qty }
                  : { id: variantId, quantity: 0 },
                dataType: 'json',
                timeout: AJAX_TIMEOUT_MS,
                success: resolve,
                error: reject
              });
            });

          } catch (itemErr) {

            if (isRateLimited(itemErr)) {
              reloadPageOnFailure(
                `Cart change rate limited (429) on variant ${variantId}`
              );
              return;
            }

            const reason = itemErr?.responseJSON?.description
              || itemErr?.responseJSON?.message
              || itemErr?.responseText
              || itemErr;

            console.error(
              `Skipping variant ${variantId} — Shopify rejected it:`,
              reason
            );

            if (qty > 0) {
              UNAVAILABLE_VARIANTS.add(String(variantId));
            }
          }
        }
      }

      // Refresh cart UI
      await new Promise(resolve => {
        if (window.location.pathname === '/cart') {
          updateCartPageAjax(resolve);
        } else {
          refreshCartDrawer(resolve);
        }
      });

    } catch (err) {
      console.error('Cart gift sync failed unexpectedly:', err);

    } finally {
      if (mainCart) {
        mainCart.classList.remove('loading');
      }

      if (cartDrawer) {
        $(cartDrawer).removeClass('loading');
      }

      isUpdatingGifts = false;
      toggleCheckoutButtons(false);
    }
  }


  // =========================================================================
  // Cart page UI replacement
  // =========================================================================

  function updateCartPageAjax(callback) {
    $.get(location.href, function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const selectors = [
        '#main-cart-items',
        '#main-cart-footer',
        '.cart__footer',
        '#cart-icon-bubble',
        '.cart-count-bubble',
        '#CartCount',
        '.cart-count'
      ];

      selectors.forEach(selector => {
        const newEl = doc.querySelector(selector);
        const currentEl = document.querySelector(selector);

        if (newEl && currentEl) {
          currentEl.innerHTML = newEl.innerHTML;
          currentEl.className = newEl.className;
        }
      });

    }).fail(function (xhr) {
      if (xhr && xhr.status === 429) {
        reloadPageOnFailure('Cart page refresh (GET /cart) rate limited (429)');
      }
    }).always(function () {
      const mainCart = document.querySelector('#main-cart-items');
      if (mainCart) {
        mainCart.classList.remove('loading');
      }
      if (callback) {
        callback();
      }
    });
  }


  // =========================================================================
  // Cart drawer refresh
  // =========================================================================

  function refreshCartDrawer(callback) {
    $.get(location.href, function (html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newCartDrawer = doc.querySelector('cart-drawer.drawer');
      const cartDrawer = document.querySelector('cart-drawer.drawer');

      if (newCartDrawer && cartDrawer) {
        const classesToKeep = ['active', 'is-open', 'open', 'opened', 'transition', 'loading'];
        const keptClasses = classesToKeep.filter(cls => cartDrawer.classList.contains(cls));

        cartDrawer.className = newCartDrawer.className;
        keptClasses.forEach(cls => cartDrawer.classList.add(cls));
      }

      const newInner = doc.querySelector('#CartDrawer');
      const currentInner = document.querySelector('#CartDrawer');

      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      }

      ['#cart-icon-bubble', '.cart-count-bubble', '#CartCount', '.cart-count'].forEach(sel => {
        const newEl = doc.querySelector(sel);
        const currentEl = document.querySelector(sel);

        if (newEl && currentEl) {
          currentEl.innerHTML = newEl.innerHTML;
          currentEl.className = newEl.className;
        }
      });

    }).fail(function (xhr) {
      if (xhr && xhr.status === 429) {
        reloadPageOnFailure('Cart drawer refresh (GET /cart) rate limited (429)');
      }
    }).always(function () {
      const cd = document.querySelector('cart-drawer.drawer');
      if (cd) {
        $(cd).removeClass('loading');
      }
      if (callback) {
        callback();
      }
    });
  }


  // =========================================================================
  // Entry points
  // =========================================================================

  let syncDebounceTimer = null;

  function update_cart_page() {
    clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(() => syncAllGifts(), 1000);
  }


  // =========================================================================
  // Click events
  // =========================================================================

  document.addEventListener('click', function (e) {
    const checkoutBtn = e.target.closest(
      '.gokwik-checkout, [name="checkout"], a[href="/checkout"], .cart__checkout-button'
    );

    if (checkoutBtn && isUpdatingGifts) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    if (
      e.target.closest('.quantity__button') ||
      e.target.closest('.cart-remove-button') ||
      e.target.closest('cart-remove-button')
    ) {
      toggleCheckoutButtons(true);
      update_cart_page();
    }
  }, true);


  // =========================================================================
  // Quantity changes
  // =========================================================================

  document.addEventListener('change', function (e) {
    if (e.target.closest('.quantity__input')) {
      toggleCheckoutButtons(true);
      update_cart_page();
    }
  });


  // =========================================================================
  // Theme cart update event
  // =========================================================================

  window.addEventListener('custom:cart-updated', function () {
    update_cart_page();
  });

  document.addEventListener('custom:cart-updated', function () {
    update_cart_page();
  });


  // =========================================================================
  // Watch fetch calls to cart endpoints
  // =========================================================================

  const CART_ENDPOINTS = [
    '/cart/change.js',
    '/cart/update.js',
    '/cart/add.js',
    '/cart/add',
    '/cart/change',
    '/cart/update'
  ];

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const requestUrl = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
    const isCartCall = CART_ENDPOINTS.some(endpoint => requestUrl.includes(endpoint));

    return originalFetch.apply(this, args).then(response => {
      // Catch 429s from OTHER scripts/theme code calling these cart
      // endpoints directly via fetch (not just our own $.ajax calls above).
      if (isCartCall && response.status === 429) {
        reloadPageOnFailure(`fetch() to ${requestUrl} rate limited (429)`);
        return response;
      }

      if (isCartCall && !isUpdatingGifts) {
        update_cart_page();
      }

      return response;
    });
  };


  // =========================================================================
  // Initial page load
  // =========================================================================

  document.addEventListener('DOMContentLoaded', function () {
    syncAllGifts();
  });


  // =========================================================================
  // If DOMContentLoaded already fired
  // =========================================================================

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    syncAllGifts();
  }

})();